import React, { Component, createRef } from "react";
// New canvas-based card images
import cardFrontImg from '../../images/card-front.png';
import cvsCardFrontImg from '../../images/cvs-front.png';

// Legacy imports — kept for reference, no longer used in render
// import SingleCare from '../../images/singlecare.png';
// import Rxlogo from '../../images/logo-white.png';
// import logoTagline from '../../images/logo-tagline.png';
// import lahLogo from '../../images/lah-logo.png';
// import wallmart from '../../images/wallmart-card.png';
// import cvs from '../../images/wallmart-cvs.png';

class CardFront extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carddata: props.cardData ? props.cardData : { bin: '', pcn: '', mId: '' },
            groupdata: props.groupData ? props.groupData : { groupnumber: '' }
        };
        this.frontCardCanvas = createRef();
        this.drawFrontCard = this.drawFrontCard.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            carddata: props.cardData ? props.cardData : { bin: '', pcn: '', mId: '' },
            groupdata: props.groupData ? props.groupData : { groupnumber: '' }
        }, () => {
            this.drawFrontCard();
        });
    }

    componentDidMount() {
        this.drawFrontCard();
    }

    componentDidUpdate(prevProps) {
        const prevCard = prevProps.cardData || {};
        const nextCard = this.props.cardData || {};
        const prevGroup = prevProps.groupData || {};
        const nextGroup = this.props.groupData || {};

        const changed =
            prevCard.mId !== nextCard.mId ||
            prevCard.bin !== nextCard.bin ||
            prevCard.pcn !== nextCard.pcn ||
            prevCard.classnames !== nextCard.classnames ||
            prevGroup.groupnumber !== nextGroup.groupnumber ||
            prevProps.mId !== this.props.mId ||
            prevProps.bin !== this.props.bin ||
            prevProps.pcn !== this.props.pcn ||
            prevProps.PrimaryGn !== this.props.PrimaryGn;

        if (changed) {
            this.drawFrontCard();
        }
    }

    drawFrontCard() {
        const canvas = this.frontCardCanvas.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        const carddata = this.state.carddata || {};
        const groupdata = this.state.groupdata || {};
        const isCvs = carddata.classnames === 'cvs_card';

        // Resolve dynamic field values — same fallback logic as old HTML
        const mId = carddata.mId || this.props.mId || '';
        const bin = this.props.bin || carddata.bin || '';
        const pcn = this.props.pcn || carddata.pcn || '';
        const group = this.props.PrimaryGn || groupdata.groupnumber || '';

        const img = new Image();

        img.onload = () => {
            // Support high-DPI displays
            const dpr = window.devicePixelRatio || 1;

            // Set canvas internal resolution (high DPI)
            canvas.width = img.width * dpr;
            canvas.height = img.height * dpr;

            // Reset CSS size — let CSS / wrapper control display size
            canvas.style.width = '';
            canvas.style.height = '';

            // Scale context to match DPI
            ctx.scale(dpr, dpr);

            // Draw the card image as the base
            ctx.drawImage(img, 0, 0, img.width, img.height);

            const W = img.width;
            const H = img.height;

            ctx.textAlign = 'left';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = '#ffffff';

            // Single font size for all text — slightly smaller than the old member ID value
            const fontSize    = Math.floor(W * 0.044);
            const lineGap     = H * 0.115;

            // CVS card image has its data area lower than the standard card
            const startY = isCvs ? H * 0.46 : H * 0.38;

            // ── LEFT COLUMN: Member ID label + value stacked ──────────────────
            const leftX      = W * 0.12;   // aligned with bottom "Show this card" strip
            const leftStartY = startY;

            // "MEMBER ID" label
            ctx.font = `600 ${fontSize}px 'Urbanist', Arial, sans-serif`;
            ctx.fillText(isCvs ? 'Member ID' : 'MEMBER ID', leftX, leftStartY);

            // Member ID value below label (same font size, regular weight)
            ctx.font = `400 ${fontSize}px 'Urbanist', Arial, sans-serif`;
            ctx.fillText(mId, leftX, leftStartY + lineGap);

            // ── RIGHT COLUMN: Bin, Group, PCN ─────────────────────────────────
            const rightX      = W * 0.55;
            const rightStartY = startY;

            const rightFields = [
                { label: 'Bin:',   value: bin   },
                { label: 'PCN:',   value: pcn   },
                { label: 'Group:', value: group },
            ];

            rightFields.forEach(({ label, value }, i) => {
                const py = rightStartY + i * lineGap;
                // label semi-bold, value regular — on the same line
                ctx.font = `600 ${fontSize}px 'Urbanist', Arial, sans-serif`;
                const labelText  = label + ' ';
                const labelWidth = ctx.measureText(labelText).width;
                ctx.fillText(labelText, rightX, py);

                ctx.font = `400 ${fontSize}px 'Urbanist', Arial, sans-serif`;
                ctx.fillText(value, rightX + labelWidth, py);
            });
        };

        img.onerror = () => {
            console.error('CardFront: Failed to load card image');
        };

        img.src = isCvs ? cvsCardFrontImg : cardFrontImg;
    }

    render() {
        return (
            <canvas
                ref={this.frontCardCanvas}
                style={{ height: 'auto', borderRadius: 16, display: 'block' }}
                aria-label="Prescription Savings Card"
            />
        );

        /* Legacy HTML card markup — replaced by canvas above
        return (
            <>
                {
                    this.state.carddata && this.state.carddata.classnames === 'cvs_card' ?
                        <>
                            <div className="order_card card_front glic_card cvs_card">
                                <div className="side-icon"></div>
                                <div className="card_header">
                                    <div className="card_heading">
                                        <img src={SingleCare} className="img-fluid card_logo" alt="Siglecare Logo" />
                                        <div className="header_info">For exclusive use at <img src={cvs} alt="CVS Logo" /></div>
                                    </div>
                                    <div className="tagline">Pharmacy Savings Card</div>
                                </div>
                                <div className="card_body">
                                    <div className="prescription-info">Save up to 80% on your prescriptions.</div>
                                    <div className="member-info">
                                        <div className="memberid">Member ID <span>{this.state.carddata.mId}</span></div>
                                    </div>
                                    <div className="card_info">
                                        <div>Bin: <span>{this.state.carddata.bin}</span></div>
                                        <div>Group: <span>{this.state.groupdata.groupnumber}</span></div>
                                        <div>PCN: <span>{this.state.carddata.pcn}</span></div>
                                    </div>
                                </div>
                                <div className="card_footer">
                                    <div className="footer-left">Show this card to save up to 80% on your prescriptions</div>
                                    <div className="footer-right">
                                        <div className="insurance-text">This card is free. This is not insurance.</div>
                                        <p>Customer Service: 1-800-999-3053</p>
                                    </div>
                                </div>
                            </div>
                        </> :
                        <>{this.state.carddata && this.state.carddata.classnames === 'walmart_card' ?
                            <>
                                <div className="order_card card_front glic_card">
                                    <div className="side-icon"></div>
                                    <div className="card_header">
                                        <div className="card_heading">
                                            <img src={SingleCare} className="img-fluid card_logo" alt="Siglecare Logo" />
                                            <div className="header_info">Pharmacy Savings</div>
                                        </div>
                                        <div className="tagline">Save on your prescription medications</div>
                                    </div>
                                    <div className="card_body">
                                        <div className="prescription-info">Available at<br /><img src={wallmart} alt="Walmart Logo" /></div>
                                        <div className="card_info">
                                            <div>Member ID: <span>{this.state.carddata.mId}</span></div>
                                            <div>Bin: <span>{this.state.carddata.bin}</span></div>
                                            <div>Group: <span>{this.props.PrimaryGn ? this.props.PrimaryGn : this.state.groupdata.groupnumber}</span></div>
                                            <div>PCN: <span>{this.state.carddata.pcn}</span></div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <div className="insurance-text">This card is not insurance.</div>
                                    </div>
                                </div>
                            </> :
                            <>
                                <div className="order_card card_front glic_card">
                                    <div className="side-icon"></div>
                                    <div className="card_header">
                                        <img src={logoTagline} className="img-fluid card_logo" alt="NuLifeSpan Rx" />
                                    </div>
                                    <div className="card_body">
                                        <div className="member-info">
                                            <div className="memberid">MEMBER ID <span>{this.state.carddata.mId ? this.state.carddata.mId : this.props.mId}</span></div>
                                        </div>
                                        <div className="card_info">
                                            <div>BIN: <span>{this.props.bin ? this.props.bin : this.state.carddata.bin}</span></div>
                                            <div>PCN: <span>{this.props.pcn ? this.props.pcn : this.state.carddata.pcn}</span></div>
                                            <div>GROUP: <span>{this.props.PrimaryGn ? this.props.PrimaryGn : this.state.groupdata.groupnumber}</span></div>
                                        </div>
                                    </div>
                                    <div className="card-strip">Show this card to save up to 80% on your prescriptions</div>
                                    <div className="card_footer">
                                        <div className="footer-benefiting">
                                            <img src={lahLogo} className="lah-logo" alt="Little Angel's Hope" />
                                            <div className="benefiting-text">
                                                <span className="benefiting-label">BENEFITING:</span>
                                                <span className="benefiting-name">{this.props.groupData && this.props.groupData.beneficiaryName ? this.props.groupData.beneficiaryName : ''}</span>
                                            </div>
                                        </div>
                                        <div className="footer-insurance">
                                            <div className="insurance-text">This card is free. This is not insurance.</div>
                                            <p>Customer Service: 1-800-999-3053</p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }</>
                }
            </>
        )
        */
    }
}
export default CardFront;
